
































































import { computed, defineComponent } from '@vue/composition-api';
import { ParagraphSize, StatusType } from '@getaccept/lib-ui';

import { storeToRefs } from 'pinia';
import Search from '../search/components/Search.vue';
import GlobalSidebarIconActive from '../../sidebar/components/GlobalSidebarIconActive.vue';
import GlobalSidebarIcon from '../../sidebar/components/GlobalSidebarIcon.vue';
import { useSessionStore } from '../../session/store/session.store';
import ProductSwitcher from '../../sidebar/components/ProductSwitcher.vue';
import { useSidebarItemsStore } from '../../sidebar/store/sidebar-items.store';
import { useModulesStore } from '../../modules/store/modules.store';
import { CreateDocumentConstants } from '../constants/create-documents';
import { useAppMode } from '../../composables/app-mode.composable';
import SubscriptionInfoButton from '../../subscription/components/SubscriptionInfoButton.vue';
import { useSubscriptionStore } from '../../subscription/store/subscription.store';
import CreateDocumentButton from './CreateDocumentButton.vue';

export default defineComponent({
  name: 'GlobalNavMenu',
  components: {
    Search,
    GlobalSidebarIconActive,
    GlobalSidebarIcon,
    CreateDocumentButton,
    ProductSwitcher,
    SubscriptionInfoButton,
  },

  setup() {
    const sessionStore = useSessionStore();
    const sidebarItemsStore = useSidebarItemsStore();
    const modulesStore = useModulesStore();
    const { appMode } = useAppMode();
    // eslint-disable-next-line no-restricted-syntax
    const { isInactiveSubscription, isTrialPlan } = storeToRefs(useSubscriptionStore());

    const documentOptions = computed(() =>
      CreateDocumentConstants.documentTypes().filter(({ displayMode }) =>
        displayMode.includes(appMode.value)
      )
    );

    const showProductSwitcher = computed(
      () => modulesStore.hasDealRoomModuleAccess && modulesStore.hasContractRoomModuleAccess
    );

    const showSubscriptionButton = computed(
      // eslint-disable-next-line no-restricted-syntax
      () => isTrialPlan.value && !isInactiveSubscription.value
    );

    return {
      sessionStore,
      ParagraphSize,
      StatusType,
      sidebarItemsStore,
      modulesStore,
      showProductSwitcher,
      documentOptions,
      showSubscriptionButton,
      isInactiveSubscription,
    };
  },
});
